export const supportEmail = 'support@getfranny.com'